import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "q-mb-lg entry-check-table" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "multiline" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "email-td" };
const _hoisted_6 = {
    key: 0,
    class: "q-mb-lg entry-check-table"
};
const _hoisted_7 = { class: "text-area-cell text-red" };
const _hoisted_8 = { class: "q-mb-lg entry-check-table" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "q-pr-xs" };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { key: 2 };
const _hoisted_14 = { key: 3 };
const _hoisted_15 = { class: "multiline" };
const _hoisted_16 = { class: "q-mb-lg entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_option_group = _resolveComponent("q-option-group");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "table-caption" }, "契約情報", -1)),
        _createElementVNode("table", _hoisted_1, [
            _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("th", null, "契約者名", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.personal.keiyakusha), 1)
                ]),
                (_ctx.kaiyakuForInput.keyReturnNameKb !== 4)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                        _cache[2] || (_cache[2] = _createElementVNode("th", null, "入居者名", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.nyukyokeiyaku?.nyukyosha), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("th", null, "住所", -1)),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.addressAll), 1)
                ]),
                (_ctx.kaiyakuForInput.keyReturnNameKb !== 4)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                        _cache[4] || (_cache[4] = _createElementVNode("th", null, "その他ご契約事項", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.sonotaKeiyaku), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("th", null, "携帯電話", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.tel), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("th", null, "メールアドレス", -1)),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.taikyo.email), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("th", null, "退去予定日", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.taikyoYmd == null ? "" : _ctx.dayjs(_ctx.taikyo.taikyoYmd ?? "").format("YYYY/MM/DD")), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("th", null, "解約日", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.kaiyakuYmd == null ? "" : _ctx.dayjs(_ctx.taikyo.kaiyakuYmd ?? "").format("YYYY/MM/DD")), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("th", null, "退去理由", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.taikyoRiyuKbName) + " " + _toDisplayString(_ctx.taikyo.taikyoRiyu), 1)
                ])
            ])
        ]),
        (_ctx.taikyo.taikyoGuide)
            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("th", null, "退去に関するご案内", -1)),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.taikyo.taikyoGuide), 1)
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "table-caption" }, "解約に伴う必要事項を入力してください。", -1)),
        _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.kaiyakuForInput.keyReturnName), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.keyReturnYmd == null
                        ? ""
                        : _ctx.dayjs(_ctx.taikyo.keyReturnYmd ?? "").format(_ctx.taikyo.keyReturnNameKb === 1 || _ctx.taikyo.keyReturnNameKb === 3 ? "YYYY/MM/DD HH:mm" : "YYYY/MM/DD")), 1)
                ]),
                (_ctx.kaiyakuForInput.keyReturnNameKb === 3)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _cache[12] || (_cache[12] = _createElementVNode("th", null, "鍵返却予定店舗", -1)),
                        _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.nyukyokeiyaku?.shopName), 1),
                                _createElementVNode("div", null, "（" + _toDisplayString(_ctx.getShopAdr()) + "）", 1)
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("div", null, "または、現在お住まいの地域のミニミニ店舗へ", -1))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.kaiyakuForInput.keyReturnNameKb !== 99 && _ctx.kaiyakuForInput.keyReturnNameKb !== 4)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                        _cache[13] || (_cache[13] = _createElementVNode("th", null, "鍵返却予定数", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.numberOfReturnKeys), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.kaiyakuForInput.keyReturnNameKb === 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _cache[14] || (_cache[14] = _createElementVNode("th", null, "退去立会者", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.kaiyakuForInput.tachiaishaKbnList.find(x => x.value === _ctx.taikyo.taikyoTachiaiKb).label), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.kaiyakuForInput.keyReturnNameKb === 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _cache[15] || (_cache[15] = _createElementVNode("th", null, "退去立会者名", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.taikyoTachiaiName), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("th", null, [
                        _createTextVNode("連絡先住所（転居先）"),
                        _createElementVNode("br"),
                        _createTextVNode("書類送付先")
                    ], -1)),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.getAddressRenraku()), 1)
                ])
            ])
        ]),
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "table-caption" }, "返金先口座", -1)),
        _createElementVNode("table", _hoisted_16, [
            _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("th", { rowspan: "2" }, "返金先口座", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.henkinBankName) + "銀行", 1)
                ]),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.henkinBansName) + "支店", 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[18] || (_cache[18] = _createElementVNode("th", null, "口座種別", -1)),
                    _createElementVNode("td", null, [
                        _createVNode(_component_q_option_group, {
                            modelValue: _ctx.taikyo.henkinKouzaSb,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.taikyo.henkinKouzaSb) = $event)),
                            options: _ctx.kouzaForInput,
                            inline: "",
                            disable: ""
                        }, null, 8, ["modelValue", "options"])
                    ])
                ]),
                _createElementVNode("tr", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("th", null, "口座番号", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getKouzaNo()), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[20] || (_cache[20] = _createElementVNode("th", null, "口座名義", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.henkinKouzaName), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("th", null, "口座名義（ｶﾅ）", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.henkinKouzaKana), 1)
                ])
            ])
        ])
    ], 64));
}
